'use strict';

angular.module('myConsultApp').service('Session', function ($cookieStore, $localStorage) {
  this.accessToken = $cookieStore.get('accessToken') ? $cookieStore.get('accessToken') : null;
  this.refreshToken = $cookieStore.get('refreshToken') ? $cookieStore.get('refreshToken') : null;
  this.expiresIn = $cookieStore.get('expiresIn') ? $cookieStore.get('expiresIn') : null;
  this.id = $localStorage.currentUser ? $localStorage.currentUser.id : null;
  this.userId = $localStorage.currentUser ? ($localStorage.currentUser.contact_information ? $localStorage.currentUser.contact_information.email : $localStorage.currentUser.email ): null;

  this.create = function (sessionId, userId) {
    this.id = sessionId;
    this.userId = userId;
    //this.userRole = userRole;
  };

  this.destroy = function () {
    this.id = null;
    this.userId = null;
    this.accessToken = null;
    this.refreshToken = null;
    this.expiresIn = null;
    //this.userRole = null;

    $cookieStore.remove('csrftoken');
    $cookieStore.remove('sessionid');
    $cookieStore.remove('currentUser');
    $cookieStore.remove('accessToken');
    $cookieStore.remove('refreshToken');
    $cookieStore.remove('expiresIn');
    $cookieStore.remove('baseAccessToken');
    $cookieStore.remove('baseRefreshToken');
    $cookieStore.remove('baseExpiresIn');
    $cookieStore.remove('baseUserId');
    $localStorage.tabOpened_accessToken = null;
    $localStorage.tabOpened_refreshToken = null;
    $localStorage.tabOpened_expiresIn = null;
  };

  this.loadTokens = function () {
    this.accessToken = $cookieStore.get('accessToken');
    this.refreshToken = $cookieStore.get('refreshToken');
    this.expiresIn = $cookieStore.get('expiresIn');
    this.baseAccessToken = $cookieStore.get('baseAccessToken');
    this.baseRefreshToken = $cookieStore.get('baseRefreshToken');
    this.baseExpiresIn = $cookieStore.get('baseExpiresIn');
    this.baseUserId = $cookieStore.get('baseUserId')
      ? $cookieStore.get('baseUserId')
      : $localStorage.baseUserId;
  };

  this.setTokens = function (accessToken, refreshToken, expiresIn) {
    this.accessToken = accessToken;
    this.refreshToken = refreshToken;
    this.expiresIn = expiresIn;

    $cookieStore.put('accessToken', this.accessToken);
    $cookieStore.put('refreshToken', this.refreshToken);
    $cookieStore.put('expiresIn', this.expiresIn);
  };

  this.setBaseTokens = function (accessToken, refreshToken, expiresIn, baseUserId) {
    this.baseAccessToken = accessToken;
    this.baseRefreshToken = refreshToken;
    this.baseExpiresIn = expiresIn;
    this.baseUserId = baseUserId;

    $cookieStore.put('baseAccessToken', this.baseAccessToken);
    $cookieStore.put('baseRefreshToken', this.baseRefreshToken);
    $cookieStore.put('baseExpiresIn', this.baseExpiresIn);
    $cookieStore.put('baseUserId', this.baseUserId);
    $localStorage.baseUserId = this.baseUserId;
  };

  this.resetBaseTokens = function (accessToken, refreshToken, expiresIn) {
    if (accessToken) {
      this.accessToken = accessToken;
    } else {
      this.accessToken = $cookieStore.get('baseAccessToken');
    }
    if (refreshToken) {
      this.refreshToken = refreshToken;
    } else {
      this.refreshToken = $cookieStore.get('baseRefreshToken');
    }
    if (expiresIn) {
      this.expiresIn = expiresIn;
    } else {
      this.expiresIn = $cookieStore.get('baseExpiresIn');
    }

    $cookieStore.put('accessToken', this.accessToken);
    $cookieStore.put('refreshToken', this.refreshToken);
    $cookieStore.put('expiresIn', this.expiresIn);
    $cookieStore.remove('baseAccessToken');
    $cookieStore.remove('baseRefreshToken');
    $cookieStore.remove('baseExpiresIn');
    $cookieStore.remove('baseUserId');
  };

  this.removeTokens = function () {
    $cookieStore.remove('accessToken');
    $cookieStore.remove('refreshToken');
    $cookieStore.remove('expiresIn');
    $cookieStore.remove('baseAccessToken');
    $cookieStore.remove('baseRefreshToken');
    $cookieStore.remove('baseExpiresIn');
  };

  this.getBaseUser = function () {
    return $localStorage.baseUser;
  };
});
